import each from 'lodash/each';
import set from 'lodash/set';

import { FIELDS_MAPPER, DEFAULTS_FOR_NEW_CONFIGURATION } from '../chatConstants';

class ChatConfigDefaults {
  constructor() {
    each(FIELDS_MAPPER, field => set(this, field.path, field.defaultValue));
  }
}

class NewChatConfigDefaults {
  constructor() {
    each(DEFAULTS_FOR_NEW_CONFIGURATION, field => set(this, field.path, field.defaultValue));
  }
}

export const chatConfigurationDefaults = Object.freeze(new ChatConfigDefaults());
export const newChatConfigurationDefaults = Object.freeze(new NewChatConfigDefaults());
